import { useEffect, useCallback, useRef } from 'react';

const useRealTimeChat = (currentUser, onNewMessage, onChatUpdate) => {
  // Stable ref — callbacks change hone par interval reset nahi hoga
  const callbackRef = useRef({ onNewMessage, onChatUpdate });
  useEffect(() => {
    callbackRef.current = { onNewMessage, onChatUpdate };
  });

  const checkForNotifications = useCallback(async () => {
    try {
      const response = await fetch('https://buzzinguniverse.com/backend/api/chat-notification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: currentUser })
      });
      const data = await response.json();

      if (data.data.length) {
        callbackRef.current.onNewMessage && callbackRef.current.onNewMessage(data);
        callbackRef.current.onChatUpdate && callbackRef.current.onChatUpdate();
      }
    } catch (error) {
      console.error('Error checking notifications:', error);
    }
  }, [currentUser]); // sirf currentUser change par recreate ho

  useEffect(() => {
    const interval = setInterval(checkForNotifications, 15000); // 3s → 15s
    return () => clearInterval(interval);
  }, [checkForNotifications]);

  return { checkForNotifications };
};

export default useRealTimeChat;
